'use client';

import React from 'react';
import { cn } from '@/lib/utils';

interface VariantButtonProps {
  label: string;
  isSelected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  tooltipMessage?: string;
  className?: string;
}

const VariantButton: React.FC<VariantButtonProps> = ({
  label,
  isSelected = false,
  disabled = false,
  onClick,
  tooltipMessage,
  className = '',
}) => {
  const getButtonStyles = () => {
    if (disabled) {
      return `
        bg-[#F2F2F2] border-[#E0E0E0] border text-[#A6A6A6] cursor-not-allowed
        hover:bg-[#F2F2F2] hover:border-[#E0E0E0] hover:text-[#A6A6A6]
      `;
    }

    if (isSelected) {
      return `
        bg-[#333333] border-[#000000] text-white border
        hover:bg-[#333333] hover:border-[#000000] hover:text-white
      `;
    }

    // Default/Unselected state
    return `
      bg-white border-[#D9D9D9] text-black border
      hover:bg-[#F5F5F5] hover:border-[#BFBFBF] hover:text-black
    `;
  };

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <div className="relative group">
      <button
        disabled={disabled}
        onClick={handleClick}
        className={cn(
          // Base styles
          'py-3 px-6 w-max font-bold text-sm lg:text-sm rounded-lg transition-all duration-200',
          // State-specific styles
          getButtonStyles(),
          // Custom className
          className
        )}
      >
        <div className="flex items-center justify-center font-proxima_font">
          {label}
        </div>
      </button>

      {/* Tooltip for disabled state */}
      {disabled && tooltipMessage && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50 pointer-events-none">
          <div className="bg-white border border-[#CCCCCC] font-proxima_font rounded-lg px-3 py-2 text-sm text-black shadow-lg text-center w-full min-w-[100px] md:whitespace-nowrap">
            {tooltipMessage}
            {/* Tooltip arrow */}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-[#CCCCCC]"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VariantButton;
